import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AssignCodeShow = () => {
  const location = useLocation();
  const Navigate = useNavigate();

  const [productData, setProductData] = useState({});
  const [supplierData, setSupplierData] = useState({});
  const [productImages, setProductImages] = useState([]);
  const [quotationDetails, setQuotationDetails] = useState({});

  useEffect(() => {
    if (!location?.state) {
      Navigate("/admin/dashboard");
      return;
    }

    const product = location?.state?.product || {};
    const supplier = location?.state?.supplier || {};
    const quotation = {
      quotation_price: location?.state?.quotation_price,
      adminquotationPrice: location?.state?.adminquotationPrice,
      final_price: location?.state?.final_price,
      remark: location?.state?.remark,
      status: location?.state?.status,
      created_at: location?.state?.created_at,
    };

    setProductData(product);
    setSupplierData(supplier);
    setQuotationDetails(quotation);

    // ✅ Parse product images (JSON array string)
    try {
      const parsedImages = JSON.parse(product.product_image || "[]");
      setProductImages(parsedImages);
    } catch (err) {
      console.warn("Error parsing product_image:", err);
      setProductImages([]);
    }
  }, [location, Navigate]);

  const formatPrice = (price) => {
    if (!price) return "N/A";
    return `₹${Number(price).toLocaleString("en-IN")}`;
  };

  const statusColors = {
    approved: { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    rejected: { bg: "var(--color-danger-bg)", color: "var(--color-danger-text)" },
  };
  const st = statusColors[quotationDetails.status] || { bg: "var(--color-surface-2)", color: "var(--color-text-secondary)" };

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Assign Order Details</h1>
          <p className="al-sub">Product, supplier and quotation for this assigned order.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" /></svg>
        </div>
        <div>
          <div className="al-idbanner__name">{productData.title || "N/A"}</div>
          <div className="al-idbanner__sub" style={{ fontFamily: "var(--font-mono)" }}>Order #{location?.state?.order_id} · Product #{location?.state?.product_id}</div>
        </div>
        <span className="al-pill" style={{ marginLeft: "auto", textTransform: "capitalize", background: st.bg, color: st.color }}>
          {quotationDetails.status || "Pending"}
        </span>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
          <h3 className="al-cardhead__title">Product Details</h3>
        </div>
        <div className="al-spec">
          <div><div className="al-spec__lbl">Order ID</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{location?.state?.order_id}</div></div>
          <div><div className="al-spec__lbl">Product ID</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{location?.state?.product_id}</div></div>
          <div><div className="al-spec__lbl">Product Name</div><div className="al-spec__val">{productData.title || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Material Color</div><div className="al-spec__val">{productData.material_color || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Size</div><div className="al-spec__val">{productData.size || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Quantity</div><div className="al-spec__val">{productData.quantity || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Print Coverage</div><div className="al-spec__val">{productData.print_coverage || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Paper GSM</div><div className="al-spec__val">{productData.paper_gsm || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Burst Factor</div><div className="al-spec__val">{productData.burst_factor || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Lamination</div><div className="al-spec__val">{productData.lamination || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Date &amp; Time</div><div className="al-spec__val">{new Date(location?.state?.created_at).toLocaleString("en-IN")}</div></div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Images</div>
            {productImages.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "6px" }}>
                {productImages.map((img, i) => (
                  <img key={i} src={`${process.env.REACT_APP_IMAGE_URL}${img}`} alt={`Product ${i}`}
                    style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "8px", border: "1px solid var(--color-border)" }} />
                ))}
              </div>
            ) : (
              <div className="al-spec__val">No images found</div>
            )}
          </div>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg></div>
          <h3 className="al-cardhead__title">Supplier Details</h3>
        </div>
        <div className="al-spec">
          <div><div className="al-spec__lbl">Supplier ID</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{supplierData.user_id || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Supplier Name</div><div className="al-spec__val">{supplierData.name || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Email</div><div className="al-spec__val">{supplierData.email || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Company</div><div className="al-spec__val">{supplierData.company_name || "N/A"}</div></div>
          <div><div className="al-spec__lbl">Business Type</div><div className="al-spec__val">{supplierData.business_type || "N/A"}</div></div>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg></div>
          <h3 className="al-cardhead__title">Quotation Details</h3>
        </div>
        <div className="al-spec">
          <div><div className="al-spec__lbl">Supplier Quotation Price</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{formatPrice(quotationDetails.quotation_price)}</div></div>
          <div><div className="al-spec__lbl">Admin Quotation Price</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{formatPrice(quotationDetails.adminquotationPrice)}</div></div>
          <div><div className="al-spec__lbl">Final Approved Price</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{formatPrice(quotationDetails.final_price)}</div></div>
          <div>
            <div className="al-spec__lbl">Status</div>
            <div className="al-spec__val">
              <span className="al-pill" style={{ textTransform: "capitalize", background: st.bg, color: st.color }}>{quotationDetails.status || "Pending"}</span>
            </div>
          </div>
          <div><div className="al-spec__lbl">Quotation Created On</div><div className="al-spec__val">{quotationDetails.created_at ? new Date(quotationDetails.created_at).toLocaleString("en-IN") : "N/A"}</div></div>
          <div className="al-spec__full"><div className="al-spec__lbl">Supplier Description</div><div className="al-spec__val">{quotationDetails.remark || "N/A"}</div></div>
        </div>
      </div>
    </div>
  );
};

export default AssignCodeShow;
